import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { selectDepreciateSeparately } from '../../../../redux/features/selectors/orderSelectors.ts';
import { selectImprovementsById } from '../../../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { setActiveDepreciateSeparatelyID } from '../../../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { ContentBlock } from '../../../../components/Analysis/ColumnComponents/ContentBlock.tsx';
import { EffectiveAgeSeparateDepreciationTable } from '../DepreciateSeparately/EffectiveAgeSeparateDepreciationTable.tsx';
import { ImageAnalysisEffectiveAge } from '../ImageAnalysis/ImageAnalysisEffectiveAge.tsx';
import { EffectiveAgeSliderInputs } from './EffectiveAgeSliderInputs.tsx';

export const EffectiveAgeSlider = ({ id }: { id: string }) => {
  const dispatch = useAppDispatch();
  const depreciateSeparately = useAppSelector(selectDepreciateSeparately);

  const propertyType = useAppSelector((state) => selectImprovementsById(state, id)?.propertyType);

  return (
    <ContentBlock>
      <Flex flexDirection="row" alignItems="baseline" gap="0.5rem">
        <Typography variant="h4">Effective Age</Typography>
        {propertyType === 'singleFamilyResidence' && <ImageAnalysisEffectiveAge id={id} />}
      </Flex>

      <Flex
        flexDirection="column"
        marginTop={depreciateSeparately ? '0.25rem' : '-1.5rem'}
        gap="1rem"
      >
        <EffectiveAgeSliderInputs
          id={id}
          index={0}
          effectiveAgeField="effectiveAge"
          ecoLifeField="totalEconomicLife"
          label={depreciateSeparately ? 'Main Dwelling' : undefined}
          defaultEcoLifeField={
            propertyType === 'manufacturedHome' ? 'defaultEcoLifeManufactured' : 'defaultEcoLife'
          }
          enabled={true}
        />
      </Flex>
      {depreciateSeparately && (
        <>
          <EffectiveAgeSeparateDepreciationTable id={id} />
          <Flex>
            <Button
              variant="secondary"
              size="sm"
              text="Edit Depreciation"
              onClick={() => dispatch(setActiveDepreciateSeparatelyID(id))}
            />
          </Flex>
        </>
      )}
    </ContentBlock>
  );
};
